/**
 * BitacoraLightbox Component
 *
 * Fullscreen image viewer for feed posts. Closes on ESC or click outside the image.
 *
 * @module components/timeline/BitacoraLightbox
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const BitacoraLightbox = ({ src, alt, onClose }) => {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  if (!src) return null;

  return (
    <div
      className="bitacora-lightbox-backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Vista ampliada de imagen"
    >
      <button
        type="button"
        className="bitacora-lightbox-close"
        onClick={onClose}
        aria-label="Cerrar"
      >
        <i className="bi bi-x-lg"></i>
      </button>
      <img
        src={src}
        alt={alt || 'Imagen'}
        className="bitacora-lightbox-img"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

BitacoraLightbox.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default BitacoraLightbox;
